import { render } from "./RouteReminders.vue?vue&type=template&id=701c94b4&ts=true"
import script from "./RouteReminders.vue?vue&type=script&lang=ts"
export * from "./RouteReminders.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__